"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var FormGroup_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/FormGroup"));

var Grid_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Grid"));

var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));

var Label_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Label/Label"));

var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));

var Header_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment/Header"));

var Select_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Select"));

var Table_1 = require("@sportnet/ui/lib/Table");

var compareDesc_1 = tslib_1.__importDefault(require("date-fns/compareDesc"));

var format_1 = tslib_1.__importDefault(require("date-fns/format"));

var parseISO_1 = tslib_1.__importDefault(require("date-fns/parseISO"));

var PropTypes = tslib_1.__importStar(require("prop-types"));

var React = tslib_1.__importStar(require("react"));

var getProp_1 = tslib_1.__importDefault(require("sportnet-utilities/lib/getProp"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var _config_1 = tslib_1.__importDefault(require("../../../config"));

var FadedTr = styled_components_1["default"](Table_1.Tr)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  color: #999 !important;\n"], ["\n  ", ";\n  color: #999 !important;\n"])), function (_a) {
  var expanded = _a.expanded;
  return !expanded && "display: none";
});

var WidgetSportRecords =
/** @class */
function (_super) {
  tslib_1.__extends(WidgetSportRecords, _super);

  function WidgetSportRecords() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      ageCategories: [],
      rowIdExpanded: {},
      filters: {
        gender: 'M'
      }
    };

    _this.getAgeCategories = function () {
      var records = getProp_1["default"](_this.props, ['data', 'data', 'records'], []);
      var ageCategories = records.map(function (row) {
        return row.ageCategory.name;
      }).filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });

      _this.setState({
        ageCategories: ageCategories,
        filters: tslib_1.__assign(tslib_1.__assign({}, _this.state.filters), {
          ageCategory: ageCategories[0]
        })
      });
    };

    _this.formatValueToTime = function (time) {
      var mins = (time - time % 60) / 60;
      var secs = (time - mins * 60).toFixed(2);

      if (mins > 0) {
        return mins + ":" + (secs < 10 ? "0" + secs : secs);
      }

      return secs;
    };

    _this.onChangeFilter = function (e) {
      var _a;

      _this.setState({
        filters: tslib_1.__assign(tslib_1.__assign({}, _this.state.filters), (_a = {}, _a[e.target.name] = e.target.value, _a))
      });
    };

    _this.toggleRow = function (rowId) {
      var _a;

      _this.setState({
        rowIdExpanded: tslib_1.__assign(tslib_1.__assign({}, _this.state.rowIdExpanded), (_a = {}, _a[rowId] = !_this.state.rowIdExpanded[rowId], _a))
      });
    };

    return _this;
  }

  WidgetSportRecords.prototype.componentDidMount = function () {
    this.getAgeCategories();
  };

  WidgetSportRecords.prototype.render = function () {
    var _this = this;

    var records = getProp_1["default"](this.props, ['data', 'data', 'records'], []);
    var disciplines = getProp_1["default"](this.props, ['data', 'data', 'disciplines'], []);
    var _a = this.state,
        ageCategories = _a.ageCategories,
        _b = _a.filters,
        gender = _b.gender,
        discipline = _b.discipline,
        ageCategory = _b.ageCategory;
    var recordsByDiscipline = records.reduce(function (acc, row) {
      var _a;

      if (gender && row.gender !== gender || discipline && row.discipline._id !== discipline || ageCategory && row.ageCategory.name !== ageCategory) {
        return acc;
      }

      var id = (row.gender === 'M' ? 'Muži' : 'Ženy') + " - " + row.ageCategory.name + " - " + row.discipline.name;
      return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[id] = tslib_1.__spreadArrays(acc[id] || [], [row]), _a));
    }, {});
    recordsByDiscipline = Object.keys(recordsByDiscipline).reduce(function (acc, k) {
      var _a;

      var items = recordsByDiscipline[k].map(function (item) {
        var itemRecords = item.records.sort(function (a, b) {
          return compareDesc_1["default"](new Date(a.date), parseISO_1["default"](b.date));
        });
        return tslib_1.__assign(tslib_1.__assign({}, item), {
          records: itemRecords
        });
      });
      return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[k] = items, _a));
    }, {});
    return React.createElement(React.Fragment, null, React.createElement(Segment_1["default"], {
      raised: true
    }, React.createElement(Grid_1.Row, null, React.createElement(Grid_1["default"], {
      xs: 12,
      s: 4
    }, React.createElement(FormGroup_1["default"], null, React.createElement(Label_1["default"], null, "Pohlavie"), React.createElement(Select_1["default"], {
      name: "gender",
      value: this.state.filters.gender,
      onChange: this.onChangeFilter
    }, React.createElement("option", {
      value: ""
    }, "Bez rozdielu pohlavia"), React.createElement("option", {
      key: "M",
      value: "M"
    }, "Mu\u017Ei"), React.createElement("option", {
      key: "F",
      value: "F"
    }, "\u017Deny")))), React.createElement(Grid_1["default"], {
      xs: 12,
      s: 4
    }, React.createElement(FormGroup_1["default"], null, React.createElement(Label_1["default"], null, "Vekov\u00E1 kateg\u00F3ria"), React.createElement(Select_1["default"], {
      name: "ageCategory",
      value: this.state.filters.ageCategory,
      onChange: this.onChangeFilter
    }, React.createElement("option", {
      value: ""
    }, "V\u0161etky vekov\u00E9 kateg\u00F3rie"), ageCategories.map(function (i) {
      return React.createElement("option", {
        key: i,
        value: i
      }, i);
    })))), React.createElement(Grid_1["default"], {
      xs: 12,
      s: 4
    }, React.createElement(FormGroup_1["default"], null, React.createElement(Label_1["default"], null, "Discipl\u00EDna"), React.createElement(Select_1["default"], {
      name: "discipline",
      value: this.state.filters.discipline,
      onChange: this.onChangeFilter
    }, React.createElement("option", {
      value: ""
    }, "V\u0161etky discipl\u00EDny"), disciplines.map(function (d) {
      return React.createElement("option", {
        key: d.name,
        value: d.name
      }, d.name);
    })))))), Object.keys(recordsByDiscipline).map(function (key) {
      return React.createElement(Segment_1["default"], {
        raised: true,
        key: key,
        header: React.createElement(Header_1["default"], {
          withSeparator: true,
          size: "s"
        }, "" + key)
      }, React.createElement(Table_1.Table, null, React.createElement(Table_1.Thead, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Th, {
        width: 30
      }), recordsByDiscipline[key][0].discipline.parameters.map(function (p) {
        return React.createElement(Table_1.Th, {
          width: 100
        }, p.name);
      }), React.createElement(Table_1.Th, {
        width: 100
      }, "Rekord"), React.createElement(Table_1.Th, {
        width: 100
      }, "Meno a priezvisko"), React.createElement(Table_1.Th, {
        width: 100
      }, "Klub"), React.createElement(Table_1.Th, {
        width: 100
      }, "D\u00E1tum"), React.createElement(Table_1.Th, {
        width: 100
      }, "Miesto"))), React.createElement(Table_1.Tbody, null, recordsByDiscipline[key].map(function (row) {
        return React.createElement(React.Fragment, null, React.createElement(Table_1.Tr, tslib_1.__assign({}, row.records.length > 1 && {
          onClick: function () {
            return _this.toggleRow(row._id);
          }
        }), React.createElement(Table_1.Td, {
          center: true
        }, row.records.length > 1 && React.createElement("div", {
          style: {
            display: 'block',
            cursor: 'pointer'
          }
        }, React.createElement(Icon_1["default"], {
          name: _this.state.rowIdExpanded[row._id] ? 'arrow-down' : 'arrow-top'
        }))), row.discipline.parameters.map(function (p) {
          return React.createElement(Table_1.Td, null, p.value);
        }), React.createElement(Table_1.Td, null, row.records[0].record.type === 'time' ? _this.formatValueToTime(Number(row.records[0].record.value).toFixed(2)) : row.records[0].record.value), React.createElement(Table_1.Td, null, row.records[0].holders.map(function (h) {
          return h.name;
        }).join(',')), React.createElement(Table_1.Td, null, row.records[0].club.name), React.createElement(Table_1.Td, null, format_1["default"](new Date(row.records[0].date), _config_1["default"].DEFAULT_DATE_FORMAT)), React.createElement(Table_1.Td, null, row.records[0].place)), row.records.slice(1).map(function (r) {
          return React.createElement(FadedTr, {
            expanded: _this.state.rowIdExpanded[row._id]
          }, React.createElement(Table_1.Td, null), row.discipline.parameters.map(function (p) {
            return React.createElement(Table_1.Td, null, p.value);
          }), React.createElement(Table_1.Td, null, r.record.type === 'time' ? _this.formatValueToTime(Number(r.record.value).toFixed(2)) : r.record.value), React.createElement(Table_1.Td, null, r.holders.map(function (h) {
            return h.name;
          }).join(',')), React.createElement(Table_1.Td, null, r.club.name), React.createElement(Table_1.Td, null, format_1["default"](new Date(r.date), _config_1["default"].DEFAULT_DATE_FORMAT)), React.createElement(Table_1.Td, null, r.place));
        }));
      }))));
    }));
  };

  return WidgetSportRecords;
}(React.PureComponent);

WidgetSportRecords.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
      records: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        gender: PropTypes.string.isRequired,
        sport: PropTypes.string.isRequired,
        place: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        ageCategory: PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string.isRequired
        }).isRequired,
        discipline: PropTypes.shape({
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          parameters: PropTypes.arrayOf(PropTypes.shape({
            _id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
          })).isRequired
        }).isRequired,
        record: PropTypes.shape({
          type: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }).isRequired,
        holders: PropTypes.arrayOf(PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string.isRequired
        })).isRequired,
        club: PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string.isRequired
        }).isRequired
      })).isRequired,
      disciplines: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        parameters: PropTypes.arrayOf(PropTypes.shape({
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        })).isRequired
      }))
    }).isRequired
  }).isRequired
};
exports["default"] = WidgetSportRecords;
var templateObject_1;